import ModalPopUp from "components/common/ModalPopUp";
import CorporateFormContainer from "containers/CorporateForm/CorporatFormContainer";
import React, {Fragment, useState} from "react";
import HomeBanner from "./HomeBanner";
import HomeCards from "./HomeCards";
// import HomeListingMain from "./HomeListingMain";
import HomePricing from "./HomePricing";
import HomeSlider from "./HomeSlider";
const HomeMain = () => {
  const [isContactOpen, setisContactOpen] = useState(false);
  const handleModalOPen = (isOpen) => {
    if (isOpen) {
      setisContactOpen(false);
    }
  };
  return (
    <Fragment>
      <HomeBanner />
      <HomeSlider />
      <HomeCards />
      <HomePricing setisContactOpen={setisContactOpen} />
      {/* <HomeListingMain setisContactOpen={setisContactOpen}/> */}
      <ModalPopUp
        closable={true}
        visible={isContactOpen}
        footer={false}
        handleCancel={() => setisContactOpen(false)}
        centered
        className="corporate_form_modal"
        maskStyle={{backgroundColor: "#1C2745"}}
        width={560}
      >
        <CorporateFormContainer handleModalOPen={handleModalOPen} />
      </ModalPopUp>
    </Fragment>
  );
};

export default HomeMain;
